import { render, staticRenderFns } from "./baoyouClient.vue?vue&type=template&id=329d29d0&scoped=true&"
import script from "./baoyouClient.vue?vue&type=script&lang=js&"
export * from "./baoyouClient.vue?vue&type=script&lang=js&"
import style0 from "./baoyouClient.vue?vue&type=style&index=0&id=329d29d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329d29d0",
  null
  
)

export default component.exports